// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"_b-z","mainContent":"ac-z","activeSidebar":"bc-z"};